module.exports = __webpack_public_path__ + "img/1728524424022-Screenshot_20240828_103845 - Miftahul Jannah.jpg.c9143431.webp";